import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))

/**	Préfixe statique pour la fiche — un segment statique bat toujours `:param` (`01` §15.2). */
export const SafetyInvestigationRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--safety--investigations']}>
    <Route path='investigation/:investigationId/*' element={<Detail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
